/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        // clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
        // authority: process.env.REACT_APP_MSAL_AUTHORITY,
        // redirectUri: process.env.REACT_APP_REDIRECT_URI,
        clientId: "6761d8d7-494f-4808-a0ea-a088ef95fb3b",
        authority: "https://login.microsoftonline.com/0c78af3c-be5b-45b1-a8c8-967d8d336cb2",
        redirectUri: "https://api-access-test.sandpit.augusta.teichert.net/",
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: ["User.Read", "api://4c7397bb-d676-4bfe-b19b-54c5f3b74f29/access_as_user","api://30af65b4-bd60-4f8c-841a-e032e08bd282/BidManagerAccess"]
    scopes: ["User.Read"],
    extraScopesToConsent: [
        "api://30af65b4-bd60-4f8c-841a-e032e08bd282/BidManagerAccess",
        "api://16fc75fa-1c15-4f3d-895c-a03fb3d03f0a/user_impersonation",
        "api://4c7397bb-d676-4bfe-b19b-54c5f3b74f29/access_as_user",
    ]
};

export const graphRequest = {
    scopes: ["User.Read"]
};

export const bidManagerRequest = {
    scopes: ["api://30af65b4-bd60-4f8c-841a-e032e08bd282/BidManagerAccess"]
};

export const eightBallRequest = {
    scopes: ["api://4c7397bb-d676-4bfe-b19b-54c5f3b74f29/access_as_user"]
};

export const eightBall2Request = {
    scopes: ["api://16fc75fa-1c15-4f3d-895c-a03fb3d03f0a/user_impersonation"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

export const bidManagerConfig = {
    // bidManagerEndpoint: process.env.REACT_APP_BID_MANAGER_URI + '/api/health',
    // bidManagerPingEndpoint: process.env.REACT_APP_BID_MANAGER_URI + '/api/ping',
    // bidManagerPingDbEndpoint: process.env.REACT_APP_BID_MANAGER_URI + '/api/pingdb',
    // bidManagerEndpoint: "https://bidmanager-service-dev.azurewebsites.net" + '/api/health',
    // bidManagerPingEndpoint: "https://bidmanager-service-dev.azurewebsites.net" + '/api/ping',
    // bidManagerPingDbEndpoint: "https://bidmanager-service-dev.azurewebsites.net" + '/api/pingdb',
    // bidManagerEndpoint: "http://eagle-api-dev.augusta.teichert.net" + '/api/health',
    // bidManagerPingEndpoint: "http://eagle-api-dev.augusta.teichert.net" + '/api/ping',
    // bidManagerPingDbEndpoint: "http://eagle-api-dev.augusta.teichert.net" + '/api/pingdb',
    bidManagerEndpoint: "https://eagle-dev.lcg-rad.com" + '/api/health',
    bidManagerPingEndpoint: "https://eagle-dev.lcg-rad.com" + '/api/ping',
    bidManagerPingDbEndpoint: "https://eagle-dev.lcg-rad.com" + '/api/pingdb',

};

export const eightBallConfig = {
    // eightBallEndpoint: process.env.REACT_APP_EIGHT_BALL_URI
    eightBallEndpoint: "https://teichert-magic8ball.azurewebsites.net/api/magic8ball"
};

export const eightBall2Config = {
    // eightBallEndpoint: process.env.REACT_APP_EIGHT_BALL_2_URI
    eightBallEndpoint: "https://teichert-magic8ball-2.azurewebsites.net/api/magic8ball"
};
